module.exports = __webpack_public_path__ + "static/media/icon.053ad52f.png";